module.exports = __webpack_public_path__ + "static/img/honorPad2.56e56a73.png";